import { useParams } from 'react-router-dom'
import { Group, Select, Skeleton, Text, Title } from '@mantine/core'
import { PillAlert } from '@shared/components/pill-alert/pill-alert'
import { useNavigation } from '@/hooks/use-navigation'

type StationHeaderProps = {
  brand: string
  recordNumber: string | undefined
  onHold: boolean
  isLoading: boolean
  stationsInGroup: { brand: string; recordNumber: string }[]
}

export function StationHeader({
  brand,
  recordNumber,
  onHold,
  isLoading = false,
  stationsInGroup = [],
}: StationHeaderProps) {
  const { navigateToAnyTab } = useNavigation()
  const { stationTabValue, woolDataTabValue, speciId } = useParams()
  const showStationSelect = !speciId && stationsInGroup.length > 0

  return (
    <Group justify='space-between'>
      {isLoading ? (
        <Skeleton visible height={34} width='60%' />
      ) : (
        <Title order={1}>
          {brand}{' '}
          <Text component='span' c='gray.5' inherit>
            {recordNumber}
          </Text>
          {onHold && <PillAlert ml='md' text='On Hold' hideIcon />}
        </Title>
      )}
      {showStationSelect && (
        <Select
          data={stationsInGroup.map((station) => ({
            value: station.recordNumber,
            label: station.brand,
          }))}
          aria-label='Switch to station in group'
          placeholder='Switch to station in group'
          value={recordNumber}
          onChange={(value) => {
            navigateToAnyTab(value, stationTabValue, woolDataTabValue)
          }}
        />
      )}
    </Group>
  )
}
